import { useContext } from "react";
import { useLocation } from "react-router-dom";
import Page from "src/components/Report/Page";
import { logoPath } from "src/config";
import jobContext from "src/context/jobContext";

const PageC = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jobId = params.get("id");
  const { job } = useContext(jobContext)
  let EVC;
  if (JSON.parse(localStorage?.data)?.[jobId]?.EVC) {
    EVC = JSON.parse(localStorage?.data)?.[jobId]?.EVC
  } else {
    EVC = []
  }
  let KSA;
  if (JSON.parse(localStorage?.data)?.[jobId]?.KSA) {
    KSA = JSON.parse(localStorage?.data)?.[jobId]?.KSA
  } else {
    KSA = []
  }

  let PI;
  if (JSON.parse(localStorage?.data)?.[jobId]?.PI) {
    PI = JSON.parse(localStorage?.data)?.[jobId]?.PI
  } else {
    PI = []
  }
  return (
    <>
      <Page isInnerPage={false}>
        <div class="flex border-2 border-black items-center justify-between h-[80px]">
          <img
            src={job.organization ? process.env.REACT_APP_API_URL + "/img/" + job.organization.logo : logoPath}
            class="w-18 h-16 ml-4 rounded mr-[5px]"
            alt="Company Logo"
          />
          <div class="flex flex-col justify-center ml-4">
            <p class="text-lg font-semibold mb-2">فرم ارزیابی عملکرد کارکنان</p>
          </div>
          <div class="flex items-center">
            <div class="bg-black text-white flex items-center justify-center w-[45px] h-[76px]">
              <p class="text-xl">C</p>
            </div>
          </div>
        </div>
        <div className="flex flex-col  items-center w-[58.99rem] h-[5.14rem]">
          <div className="flex justify-start ">
            <p className="self-start pl-[12rem]">عنوان پست:</p>
            <p className="self-start pl-[12rem]">حوزه شغلی:</p>
            <p className="self-start pl-[12rem]">کد شغل:</p>
          </div>
          <br />
          <br />
          <div className="flex justify-start mt-[-2rem]">
            <p className="self-start pl-[12rem]">حداقل تحصیلات:</p>
            <p className="self-start pl-[12rem]">رشته/گرایش:</p>
            <p className="self-start pl-[12rem]">حداقل سابقه:</p>
          </div>
        </div>
        <table className=" border-2 border-black h-[8rem] w-[56.78rem]">
          <thead className=" bg-neutral-400 border-b-2 border-black h-[3rem] ">
            <tr className="border-b-2 border-black ">
              <th className="border-r-2 border-black  rotate-90 h-[3rem}] ">
                ابعاد
              </th>
              <th className="border-r-2  border-black w-[18rem] h-[4rem]">
                مولفه
              </th>
              <th className="border-r-2  border-black w-[19rem] h-[6rem]">
                شرح
              </th>
              <th className="border-r-2  border-black border-l-2 w-[2rem] h-[6rem]">
                وزن (نسبی)
              </th>
              <div className="flex justify-center self-center items-center border-b-2 border-black">
                <th className="bt-10 text-[0.90rem]  ">
                  برنامه آموزشی و توسعه مورد قبول
                </th>
              </div>
              <div className="flex justify-center self-center items-center">
                <thead className="bg-neutral-400  ">
                  <tr>
                    <th className="border-l-2 border-black text-[0.90rem]">
                      بسیار کمتر از حد انتظار
                    </th>
                    <th className="border-l-2 border-black  text-[0.90rem]">
                      کمتر از حد انتظار
                    </th>
                    <th className=" border-l-2 border-black text-[0.90rem]">
                      در حد انتظار
                    </th>
                    <th className=" border-l-2 border-black text-[0.90rem]">
                      بیشتر از حد انتظار
                    </th>
                    <th className="text-[0.90rem]">بسیار فراتر از حد انتظار</th>
                  </tr>
                </thead>
              </div>
            </tr>
          </thead>
          {
            Object.keys(EVC).map((key, index) => {
              if (EVC[key].value >= 3) {
                return (
                  <tbody>
                    <tr>
                      <td className="border-b-2 border-black rotate-90 text-xs py-1">
                        EVC
                      </td>
                      <td className="border-r-2 border-black border-b-2 px-1 font-medium text-xs">{key}</td>
                      <td className="border-r-2 border-black border-b-2 ">{EVC[key].desc}</td>
                      <td className="border-r-2 border-black border-b-2 "></td>
                      <td className="border-r-2 border-black border-b-2 "></td>
                    </tr>
                  </tbody>
                )
              }
            })
          }
          {
            Object.keys(PI).map((key, index) => {
              if (PI[key].value >= 3) {
                return (
                  <tbody>
                    <tr>
                      <td className="border-b-2 border-black rotate-90 pr-2 text-xs py-1">
                        PI
                      </td>
                      <td className="border-r-2 border-black border-b-2 text-xs font-medium px-1">{key}</td>
                      <td className="border-r-2 border-black border-b-2 text-xs px-1">{PI[key].desc}</td>
                      <td className="border-r-2 border-black border-b-2 "></td>
                      <td className="border-r-2 border-black border-b-2 "></td>
                    </tr>
                  </tbody>
                )
              }
            })
          }

          {
            Object.keys(KSA).map((key, index) => {
              if (KSA[key].value >= 3) {
                return (
                  <tbody>
                    <tr>
                      <td className="border-b-2 border-black rotate-90 py-1 text-xs">
                        KSA
                      </td>
                      <td className="border-r-2 border-black border-b-2 px-1 font-medium text-xs">{key}</td>
                      <td className="border-r-2 border-black border-b-2 ">{KSA[key].desc}</td>
                      <td className="border-r-2 border-black border-b-2 "></td>
                      <td className="border-r-2 border-black border-b-2 "></td>
                    </tr>
                  </tbody>
                )
              }
            })
          }
        </table>
        <div className="flex border-2 border-black">
          <div className="flex border-l-2 border-black w-[38.3rem] h-[6rem] mr-[5px]">
            <p className=" justify-start">
              *برای محاسبه امتیاز نهایی عدد مربوط به گزینه انتخاب شده را به وزن
              مربوطه ضرب کرده، اعداد بدست آمده را جمع نمایید.
            </p>
          </div>

          <div className="mr-[5px]">
            <p className="text-start">محل امضای ارزیابی کننده:</p>
          </div>
        </div>
      </Page>
    </>
  );
};

export default PageC;
